const refRoutes = [
    {
        path: '/reference-data/simulation',
        name: 'Simulation',
        icon: 'null',
    },
    {
        path: '/data-model',
        name: 'Data Model',
        icon: 'null',
        children: [
            {
                path: '/reference-data/data-dictionary',
                name: 'Data Dictionary',
            },
            {
                path: '/reference-data/group-setup',
                name: 'Group Setup',
            },
            {
                path: '/reference-data/group-configuration',
                name: 'Group Configuration',
            },
        ],
    },
    {
        path: '/ingestion',
        name: 'Ingestion',
        icon: 'null',
        children: [
            {
                path: '/reference-data/source-setup',
                name: 'Source Setup',
            },
            {
                path: '/reference-data/source-configuration',
                name: 'Source Configuration',
            },
            {
                path: '/reference-data/group-source-field-map',
                name: 'Group Source Field Map',
            },
            {
                path: '/reference-data/sql-scanners',
                name: 'SQL Scanners',
            },
        ],
    },
    {
        path: '/data-governance',
        name: 'Data Governance',
        icon: 'null',
        children: [
            {
                path: '/reference-data/golden-copy-rules',
                name: 'Golden Copy Rules',
            },
            {
                path: '/reference-data/data-quality-checks',
                name: 'Data Quality Checks',
            },
            {
                path: '/reference-data/data-enrichment',
                name: 'Data Enrichment',
            },
        ],
    },
    {
        path: '/extraction',
        name: 'Extraction',
        icon: 'null',
        children: [
            {
                path: '/reference-data/push-configuration',
                name: 'Push Configuration',
            },
            {
                path: '/reference-data/push-rules',
                name: 'Push Rules',
            },
            {
                path: '/reference-data/report-configuration',
                name: 'Report Configuration',
            },
            {
                path: '/reference-data/report-group-field-map',
                name: 'Report Group Field Map',
            },
            {
                path: '/reference-data/report-schedulers',
                name: 'Report Schedulers',
            },
        ],
    },
    {
        path: '/explorer',
        name: 'Explorers',
        icon: 'null',
        view: 1,
        children: [
            {
                path: '/reference-data/blocdata-explorer',
                name: 'Source Data Explorer',
            },
            {
                path: '/reference-data/refdata-goldencopy',
                name: 'Golden Copy Explorer',
            },
        ],
    },
    
    {
        path: '/entitlement',
        name: 'Entitlements',
        icon: 'null',
        children: [
            {
                path: '/entitlement/user',
                name: 'Users',
            },
            {
                path: '/entitlement/roles',
                name: 'Roles',
            },
            {
                path: '/entitlement/role-auths',
                name: 'Role Configurations',
            },
        ],
    },
]

export default refRoutes;